module.exports = __webpack_public_path__ + "static/media/chat.e8bf29d1.png";